<template>
  <div
    class="flex w-fit min-w-fit items-center space-x-1 whitespace-nowrap rounded-xl bg-purple-700 py-1 pl-1 pr-2"
  >
    <img src="./assets/plane.svg" alt="" width="16" height="16" />
    <span class="text-static-white text-xs font-medium">
      {{ t('charter.charterFlight') }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
</script>

<i18n src="../locales.json"></i18n>
